// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"XP-z","inlineTitle":"YP-z","sponsoredAdsWrapper":"ZP-z","marketplaceRecosWrapper":"_P-z"};